export enum DeliveryAccess {
    ACCESS_VEHICLE_SIZE = 'accessVehicleSize',
    ACCESS_WITHIN_20M = 'accessWithin20m',
    ACCESS_IS_SAFE = 'accessIsSafe'
}
